import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Cta } from 'apps/dashboard/shared/scripts/components';

interface Props {
  cardId: string;
}

const SendCard = ({ cardId }: Props) => {
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate(`/dashboard/cards/${cardId}/delivery?rd=1`);
  }, [cardId, navigate]);

  return (
    <Cta faIcon={faEnvelopeOpenText} onClick={onClick} mobile>
      Send
    </Cta>
  );
};

SendCard.displayName = 'SendCard';

export default SendCard;
